// JS elimina un producto del carrito de compras

js_cart_delete()
function js_cart_delete(){
    document.addEventListener('DOMContentLoaded', cartDelete)
}

function cartDelete() {
    const buttons = document.querySelectorAll('.js-cart-delete')

    init()

    function init(){
        delteItem()
    }

    function delteItem(){
        if (buttons != null) {
            buttons.forEach(button => {
                var data = { updates: {} }
                button.addEventListener('click', e =>{
                    e.preventDefault()
                    data.updates[button.dataset.key] = 0
                    deleteLineMultiple(data)
                })
            })
        }
    }

    function deleteLineMultiple(data){
        $.ajax({
            url: "/cart/update",
            type: "post",
            data: data,
            dataType: 'json',
            async: false,
            success: () => {
                window.location = '/cart'
            },
            error: err => {
                console.log(err)
            }
        }) 
    }
}
